module.exports = __webpack_public_path__ + "static/fonts/Inter-Medium.3bd1056.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Inter-Medium.otf
// module id = 849
// module chunks = 117